import { render, staticRenderFns } from "./NewConfirmDesign.vue?vue&type=template&id=037578c0"
import script from "./NewConfirmDesign.vue?vue&type=script&lang=js"
export * from "./NewConfirmDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports